<div [ngClass]="{'fixed-menu': isSticky}">
  <div class="container new-header">
  <div class="row">
    <!-- Logo Section -->
    <div class="col-4">
      <div class="d-flex justify-content-between align-items-center">
        <img
        style="cursor: pointer;"
          alt="VectorI3179"
          src="/assets/external/LogoFull.svg"
          class="img-fluid"
          (click)="goHome()"
        />
      </div>
    </div>

    <!-- Menu Items Section -->
    <div class="col-8 d-flex align-items-center" style="justify-content: flex-end;">
      <div class="nav-container row w-100 d-flex align-items-center">
        <div class="w-auto" (click)="goHome()" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <span class="home-text021"><span>Home</span></span>
        </div>
        <div class="w-auto" (click)="goAboutUs()" routerLink="/about-us" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <span class="home-text021"><span>Nosotros</span></span>
        </div>
        <!-- <div class="w-auto" (click)="goBenefits()">
          <span class="home-text023"><span>Beneficios</span></span>
        </div> -->
        <div class="w-auto" (click)="goInsured()" routerLink="/insured" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <span class="home-text021"><span>Viajeros</span></span>
        </div>
        <div class="button-container">
          <button type="submit" (click)="goQuote()" class="btn btn-primary continue-btn-steps">Cotizar Seguro</button>
        </div>
        <div class="w-auto">
          <a href="https://blue.portal.wemarkforyou.com/" class="user-dropdown portal-login-link">
            <img src="./assets/img/user-icon.png" alt="" />
            <span class="home-text025">Acceso al Portal</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>